import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseListSearch } from "@/features/specialists";
import { SpecialistsPage } from "@/features/specialists/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/specialists/")({
  validateSearch: strictSearch(parseListSearch),
  component: List,
});

function List() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <SpecialistsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(userId) =>
        router.buildLocation({ to: "/specialists/$userId", params: { userId } }).href
      }
      onOpen={(userId) => void router.navigate({ to: "/specialists/$userId", params: { userId } })}
    />
  );
}
